import React from 'react';
import PropTypes from 'prop-types';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import SelectArrayInput from 'components/input/SelectArrayInput/SelectArrayInput';
import TextFilter from 'components/list/Filters/types/TextFilter';
import countries from 'helpers/countriesHelper';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import pointsOfInterestHelper from 'helpers/pointsOfInterest';

const NameComponent = <TextFilter
    label='resources.points_of_interest.fields.name'
    source='name'
    options={ {
        floatingLabelFixed: true,
        fullWidth: true,
    } }
/>;

const CityComponent = <TextFilter
    label='resources.points_of_interest.fields.city'
    source='city'
    options={ {
        floatingLabelFixed: true,
        fullWidth: true,
    } }
/>;

const CountryComponent = <SelectArrayInput
    allowEmpty
    label='resources.points_of_interest.fields.country'
    source='country_iso2'
    optionValue='ISO2'
    translateChoice={ true }
    choices={ countries }
    options={ {
        listStyle: {
            overflow: 'auto',
            maxHeight: 200,
        },
        fullWidth: true,
        floatingLabelFixed: true,
    } }
/>;

const TypeComponent = <SelectArrayInput
    allowEmpty
    label='resources.points_of_interest.fields.type'
    source='type'
    choices={ pointsOfInterestHelper.getLabeledTypes() }
    options={ {
        listStyle: {
            overflow: 'auto',
            maxHeight: 200,
        },
        fullWidth: true,
        floatingLabelFixed: true,
    } }
/>;

const PointsOfInterestListFilters = (props) => {
    const filters = {
        basic: {
            name: {
                component: NameComponent,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            city: {
                component: CityComponent,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            type: {
                component: TypeComponent,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
        advanced: {
            country_iso2: {
                component: CountryComponent,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

PointsOfInterestListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default PointsOfInterestListFilters;



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/list/PointsOfInterestListFilters.js